import { css } from '@emotion/core'
import { mediumUp, smallOnly } from 'Utils'

export default ({ theme }) => {
  const { twoColumnLayout, typography, colors, spacing, mixins } = theme
  const { defaultHeadingFont } = mixins
  return css`
    ${twoColumnLayout}

    /* topbar */
    @media ${smallOnly} {
      .topbar {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 8px;
        padding: 0 !important;
        gap: 12px;
        .breadcrumbs {
          margin-bottom: 0;
        }
        .topbar-search {
          .search-input {
            width: 100%;
          }
        }
      }
    }
    @media ${mediumUp} {
      .topbar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        .breadcrumbs {
          margin-bottom: 0;
        }
        .topbar-search {
          flex: 1;
          .search-input {
            width: 100%;
          }
        }
      }
    }

    /* grid overrides */
    @supports (display: grid) {
      @media ${mediumUp} {
        grid-template-areas:
          'breadcrumbs breadcrumbs breadcrumbs breadcrumbs'
          'heading heading heading sorting'
          'filters product-list product-list product-list';
      }
    }

    /** mobile filter panels **/
    .dialog-title {
      padding: 1rem;
      text-transform: uppercase;
      font-family: ${typography.headings.fontFamily};
      font-size: 1.25rem;
      text-align: center;
    }

    .filter-btn {
      padding: 0.75rem;
      font-size: 1rem;
      text-transform: uppercase;
      line-height: 1rem;
      font-family: ${typography.headings.fontFamily};
    }

    .clear-btn {
      border: 1px solid ${colors.active};
      color: ${colors.active};
      background-color: ${colors.bodyBackground};
    }

    .apply-btn {
      background-color: ${colors.active};
      color: ${colors.bodyBackground};
    }
    /** end mobile filter panels **/

    /** spacing mobile **/
    @media ${smallOnly} {
      .breadcrumbs,
      .heading,
      .product-list-actions,
      .category-slider {
        margin-bottom: ${spacing.vertical.small};
      }
    }

    /** FILTERS **/
    @media ${mediumUp} {
      .parent {
        margin-bottom: 2px;
      }

      .filters {
        background-color: ${colors.bg4};
        padding: 1rem;
        margin-left: 1rem;

        h3 {
          color: ${colors.text2};
          font-size: ${typography.sizes.larger};
          ${defaultHeadingFont(theme)}

          &.current-category-heading {
            color: ${colors.active};
            font-size: 1rem;
            font-family: ${typography.body.fontFamily};
          }
        }

        a:hover {
          text-decoration: underline;
        }
      }

      .collapsable {
        margin-bottom: 2px;
      }

      .price-filter,
      .sale-filter,
      .category-filter,
      .store-filter,
      .top-level-category-filter {
        margin-bottom: 1.6rem;
      }
    }

    /* prevent layout shifting when loading */
    .heading {
      line-height: 1.2;
      word-wrap: break-word;
      min-height: calc(1rem + ${typography.sizes.xlarge});
    }

    @media ${mediumUp} {
      .breadcrumbs {
        margin-bottom: 0.5rem;
      }

      .heading {
        padding-left: 1rem;
      }

      .heading,
      .sorting {
        margin-bottom: 0.5rem;
      }

      .product-list {
        padding-right: 1rem;
      }
    }

    .pagination {
      margin: 2rem auto ${spacing.vertical.small} auto;

      @media ${mediumUp} {
        margin: ${spacing.vertical.large} auto;
      }
    }

    .product-list-actions {
      width: 100%;
      display: block;
      > * {
        width: 100%;
      }
    }

    .filter-trigger {
      text-transform: uppercase;
      font-family: ${typography.headings.fontFamily};
      font-weight: bold;
      display: inline-block;
      padding: 0.5rem 3rem;
      margin-bottom: 1rem;
      height: 40px;
      width: 100%;
      vertical-align: middle;
      text-align: center;
      line-height: 1em;
      border: 1px solid ${colors.primary};
      background-color: ${colors.primary};
      color: ${colors.complementary.primary};
    }

    /** product not found **/
    .product-not-found-search-box {
      grid-column: 1/-1;
      margin-top: 3rem;
      grid-area: searchbox;
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 20vh;
      div {
        width: 5rem;
      }
      .IconEle {
        display: none;
      }
      @media ${mediumUp} {
        grid-column: 2/-1;
        height: 20vh;
        flex-direction: row;
        div {
          width: 5rem;
        }
        .IconEle {
          display: none;
        }
      }
    }

    /* grid overrides - adding Social */
    @supports (display: grid) {
      .topbar {
        grid-area: topbar;
        padding: 0 1rem;
      }

      @media ${mediumUp} {
        display: grid;
        grid-template-areas:
          'breadcrumbs breadcrumbs breadcrumbs breadcrumbs'
          'topbar topbar topbar topbar'
          'heading heading sorting sorting'
          'filters product-list product-list product-list';
        grid-template-columns: 300px 1fr 1fr 1fr;
        grid-gap: 1rem;
      }
    }
  `
}
